import React from "react";
import styles from "./MChip.module.css";
import { IconX } from "@tabler/icons-react";

export interface MChipProps {
  /**
   * Variant of the chip. 'default' = normal, 'drawerChip' = drawer style, 'filtered' = compact filter style
   */
  text: string;
  selected?: boolean;
  rightIcon?: boolean | React.ReactNode;
  onClick?: () => void;
  onRightIconClick?: () => void;
  className?: string;
  disabled?: boolean;
  variant?: "default" | "drawerChip" | "filtered" | "documentChip";
}

export const MChip: React.FC<MChipProps> = ({
  text,
  selected = false,
  rightIcon = true,
  onClick,
  onRightIconClick,
  className = "",
  disabled = false,
  variant = "default",
}) => {
  const isDrawerChip = variant === "drawerChip";
  const isFilteredChip = variant === "filtered";
  const isDocumentChip = variant === "documentChip";
  return (
    <div
      className={[
        styles.mchip,
        isDrawerChip ? styles.drawerChip : "",
        isDrawerChip && selected ? styles.drawerChipSelected : "",
        !isDrawerChip && selected ? styles.selected : "",
        isDocumentChip ? styles.documentChip : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      tabIndex={0}
      role="button"
      aria-disabled={disabled}
      onClick={disabled ? undefined : onClick}
      style={{
        userSelect: "none",
        pointerEvents: disabled ? "none" : undefined,
        ...(isFilteredChip ? { height: 28, padding: "8px 12px" } : {}),
      }}
    >
      <span className={styles.mchip__label}>{text}</span>
      {rightIcon !== false && (
        <span
          className={styles.mchip__rightIcon}
          tabIndex={-1}
          role="button"
          aria-label="Remove"
          onClick={(e) => {
            e.stopPropagation();
            if (onRightIconClick) onRightIconClick();
          }}
        >
          {rightIcon === true ? <IconX size={16} /> : rightIcon}
        </span>
      )}
    </div>
  );
};

export default MChip;
